import React from 'react';
import { FlameIcon } from 'lucide-react';
export function OfferBar() {
  return <a href="#oferta" className="flex w-full items-center justify-center gap-2 bg-ink px-4 py-2.5 text-center text-xs font-bold uppercase tracking-[0.14em] text-gold-light transition-colors duration-150 ease-out hover:text-white sm:text-sm" data-id="element-73" data-mp="130tpiybch41s">
      <FlameIcon className="h-4 w-4 shrink-0 text-gold-bright" aria-hidden="true" data-id="element-74" data-mp="t1coiu71fec5" />
      <span data-id="element-75" data-mp="faze8l6obnjn">Oferta especial · Acceso inmediato · Precio de lanzamiento</span>
    </a>;
}